import LegalDocument from "../components/LegalDocument";
import privacyContent from "../content/privacyPolicy";

export default function PrivacyPolicy() {
  return <LegalDocument pageTitle="Privacy Policy" content={privacyContent} />;
}
